import { render, staticRenderFns } from "./ViewResultScreen.vue?vue&type=template&id=51a8914a&scoped=true&"
import script from "./ViewResultScreen.vue?vue&type=script&lang=js&"
export * from "./ViewResultScreen.vue?vue&type=script&lang=js&"
import style0 from "./ViewResultScreen.vue?vue&type=style&index=0&id=51a8914a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a8914a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
